angular.module('controllers').controller('userGroupController', ['$scope', '$rootScope', '$controller', '$route', '$routeParams', '$location', 'Crud', 'Mqtt', '$sce',
	function ($scope, $rootScope, $controller, $route, $routeParams, $location, Crud, Mqtt, $sce) {

		$rootScope.path = '/user-group';
		$scope.path = $rootScope.path;
		$rootScope.modelName = 'user-group';
		$scope.pathTemplate = 'users/usergroups';
		$scope.title = 'Grup de utilizatori';

		angular.extend(this, $controller('crudController', {$scope: $scope}));

		$scope.sortType = 'user_group_name';
		$scope.defaultItem = 10;
    $rootScope.typeId = 'id';
		$scope.search.order = 'asc';
		$scope.classAction = 'td-big';
		$scope.columns = {
			//'id':{'label':'Id', 'filter':1, 'filterType':'input'},
			'user_group_name':{'label':'Nume', 'filter':1, 'filterType':'input'},
			'status':{'label':'Status', 'filter':1, 'filterType':'select'}
		};

		$scope.columns.status.options = [
			{'id':'', 'value' : ''},
			{'id':1, 'value' : 'true'},
			{'id':0, 'value' : 'false'}
		];

		$scope.additionals['status_string'] = JSON.stringify($scope.columns.status.options);

		$scope.additionals['content_type'] = 'form-urlencoded';
        $scope.additionals['columnDisplay'] = 'user_group_name';

        console.log('bg');
        /*if (typeof google === 'object' && typeof google.maps === 'object') {
            var geocoder = new google.maps.Geocoder();
        } else {
            var geocoder = false;
        }
        //var address = 'Strada Aleea Alexandru Lapedatu 30, Cluj-Napoca';
        var address = 'Strada București 22, Cluj-Napoca, România';
        geocoder.geocode({'address': address}, function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
            	console.log(results)
                $scope.lat = results[0].geometry.location.lat();
                $scope.lng = results[0].geometry.location.lng();

                console.log($scope.lat)
                console.log($scope.lng)
            }
            //46.8002123
            // 23.60499500000003

            //46.7802276
            // 23.599322099999995
        });*/

	}]
);
